module.exports = __webpack_public_path__ + "img/discoverFr.1238fb7b.png";